const populateFieldsFromParamsAndData = () => {
    const params = new URLSearchParams(window.location.search);
    console.log(params);
    const playerId = params.get('player_id');
    const param4 = params.get('param_4');
    if (playerId) {
        const playerInput = document.querySelector('.js-player-id');
        if (playerInput) {
            playerInput.setAttribute('value', playerId);
        }
    }
    if (param4) {
        const paramField = document.querySelector('.js-param-field');
        if (paramField) {
            paramField.setAttribute('value', param4);
        }
    }
    const form = document.querySelector('.js-account-deletion-form');
    if (form) {
        const studio = form.dataset.studio;
        if (studio) {
            const studioInput = document.querySelector('.js-game-studio');
            if (studioInput) {
                studioInput.setAttribute('value', studio);
            }
        }
    }
};
const handleAccountDeletionFormSubmit = () => {
    document.addEventListener('wpcf7mailsent', (event) => {
        var _a;
        const cf7Event = event;
        if (((_a = cf7Event.detail) === null || _a === void 0 ? void 0 : _a.contactFormId) === 1197) {
            const formBlock = document.querySelector('.js-account-deletion-form');
            const afterSubmitBlock = document.querySelector('.js-account-deletion-after-submit');
            if (formBlock) {
                formBlock.classList.add('d-none');
            }
            if (afterSubmitBlock) {
                afterSubmitBlock.classList.remove('d-none');
            }
        }
    });
};
const initAccountDeleteionForm = () => {
    populateFieldsFromParamsAndData();
    handleAccountDeletionFormSubmit();
};
document.addEventListener('DOMContentLoaded', initAccountDeleteionForm, false);
export {};
